import { UploadUpdateProps } from '@anm/components/stream/types';
import { useDispatch } from 'react-redux';

import { streamActions } from '../../../store/modules/stream';

const useUpdateUpload = () => {
  const dispatch = useDispatch();

  const handleUpdateUpload = ({ error, isPending }: UploadUpdateProps) => {
    dispatch(
      streamActions.updateDestinationMetaEntity({
        error,
        isError: !!error,
        isPending: !!isPending
      })
    );
  };

  return handleUpdateUpload;
};

export default useUpdateUpload;
